// extracted by mini-css-extract-plugin
export var input = "Input-module--input--8a68e";
export var inputLabel = "Input-module--input-label--82e5b";
export var labelText = "Input-module--label-text--05630";
export var required = "Input-module--required--4748e";